import React, { useEffect } from "react";
import { Workbox } from 'workbox-window';

const ServiceWorkerRegistration = () => {
    useEffect(() => {
        // Nie rejestruj service workera w trybie deweloperskim
        if (process.env.NODE_ENV === 'development') {
            // Wyrejestruj istniejące service workery
            if (window && window.navigator && 'serviceWorker' in navigator) {
                navigator.serviceWorker.getRegistrations().then(registrations => {
                    for (let registration of registrations) {
                        registration.unregister();
                        console.log('Service Worker unregistered for development mode');
                    }
                });
            }
            return;
        }
        
        // Register the service worker tylko w produkcji
        if (window && window.navigator && ('serviceWorker' in navigator)) {
            const wb = new Workbox('/sw.js');

            wb.addEventListener('installed', event => {
                console.log("Service worker installed")
                if (event.isUpdate) {
                    console.log("Updated the service worker")
                    window.location.reload();
                }
            });

            wb.register();
        }
    }, []);
    
    return <></>
}

export default React.memo(ServiceWorkerRegistration);